import { GET_STAFFS, GET_STAFF_BY_ID, OPEN_ADD_STAFF_MODAL, SORT_STAFFS } from '../actions/types';
import _ from 'lodash';

const INITIAL_STATE = {
    list: [],
    selectedStaff: {
        name: '',
        email: '',
        phone: '',
        address: {
            address_1: '',
            address_2: '',
            postcode: '',
            town_city: '',
            state: '',
            country: ''
        }
    },
    sortColumn: 'name',
    sortDirection: 'ascending',
    staffModalOpen: false
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_STAFFS:
            return {
                ...state,
                list: action.payload,
                staffModalOpen: false
            }

        case GET_STAFF_BY_ID:
            let staff = state.list.find((staff) => staff._id === action.payload);
            return {
                ...state,
                selectedStaff: staff,
                staffModalOpen: true
            }

        case OPEN_ADD_STAFF_MODAL:
            return {
                ...state,
                selectedStaff: {
                    name: '',
                    email: '',
                    phone: '',
                    address: {
                        address_1: '',
                        address_2: '',
                        postcode: '',
                        town_city: '',
                        state: '',
                        country: ''
                    }
                },
                staffModalOpen: action.payload
            }

        case SORT_STAFFS:
            let sorted = null;
            let sort_column = action.payload;
            let direction = 'ascending';
            if (state.sortColumn !== sort_column) {
                console.log('Sorting by ' + sort_column);
                sorted = _.sortBy(state.list, [sort_column]);
            } else {
                sorted = state.list.reverse();
                console.log(sorted);
                direction = (state.sortDirection === 'ascending') ? 'descending' : 'ascending';
                console.log('Sorting in ' + direction);
            }

            return {
                ...state,
                list: sorted,
                sortColumn: sort_column,
                sortDirection: direction
            }

        default:
            return state;
    }
}